import axios from "axios";
import { BarChart3, Briefcase, Building, FileText, Layers, Scale, Users } from "lucide-react";
import React, { useEffect, useState } from "react";
import { ICON_MAP } from "../../utilities/iconcatalog.tsx";

export function FestivalAds({ T, client, baseUrl, handleChipClick, from }) {

  const [skills, setSkills] = useState([]);
  useEffect(() => {
    if (!client?.uid) return;

    axios
      .get(baseUrl + "/getSkills", { params: { client_uid: client.uid } })
      .then((response) => {
        if (response.data.status === "OK") {
          setSkills(response.data.data);
        }
      });
  }, [client]);

  return (
    <section className="w-full py-16 bg-gradient-to-r from-gray-50 via-white to-gray-100 text-gray-900 px-6">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="flex flex-col sm:flex-row justify-between items-center mb-10">
          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wide text-[var(--primary-color)] mb-1">
              Aktuelle kampanjer
            </h3>
            <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900">
              Gratis førstegangskonsultasjon – begrenset periode
            </h2>
            <p className="text-gray-600 mt-2">
              Tilbud på juridiske tjenester innen eiendom, kontrakt, selskapsrett og arbeidsrett.
            </p>
          </div>
          <button
            className="mt-6 sm:mt-0 text-white px-6 py-3 rounded-xl font-semibold shadow transition hover:brightness-90"
            style={{ backgroundColor: "var(--primary-color)" }}
          >
            Utforsk tilbud
          </button>
        </div>

        {/* Service categories */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-4 mb-12">
          {skills.map((item, i) => {
            let HeaderIcon = null;


            const iconDef = item.picture ? ICON_MAP[item.picture] : undefined;
            HeaderIcon = iconDef?.Icon || Layers;
            return (<button
              key={i}
              onClick={() => handleChipClick(item.name)}
              className="flex flex-col items-center justify-center rounded-xl border border-gray-200 bg-white p-5 hover:shadow-md hover:border-[var(--primary-color)] transition text-center cursor-pointer"
            >
              {HeaderIcon && (
                <HeaderIcon className="w-6 h-6 text-[var(--primary-color)] mb-2" />
              )}
              <span className="font-medium text-gray-800 text-sm sm:text-base">
                {item.name}
              </span>
            </button>)
          })}
        </div>

        {/* Footer callout */}
        <div className="rounded-2xl py-6 px-6 flex flex-col sm:flex-row items-center justify-between shadow-sm"
          style={{ backgroundImage: "linear-gradient(to right, var(--primary-color), var(--secondary-color))" }}
        >
          <p className="text-gray-800 text-base sm:text-lg mb-4 sm:mb-0">
            Fant du ikke det du lette etter? <span className="font-semibold">Se alle rådgivere</span>
          </p>
          <button onClick={() => window.location.href = '/agents'} className="text-white px-6 py-3 rounded-xl font-semibold shadow transition hover:brightness-90"
            style={{ backgroundColor: "var(--primary-color)" }}
          >
            Alle rådgivere
          </button>
        </div>
      </div>
    </section>
    // <section
    //   className="py-12 px-4 max-w-6xl mx-auto"
    //   onMouseEnter={() => setPaused(true)}
    //   onMouseLeave={() => setPaused(false)}
    // >
    //   <h2 className="text-xl font-bold text-gray-900 mb-6 flex items-center gap-2">
    //     <Megaphone className="w-6 h-6 text-purple-600" /> {T.festivalTitle}
    //   </h2>
    //   <div className={`rounded-3xl p-8 bg-gradient-to-r ${c.gradient} shadow-lg transition-all duration-300`}>
    //     <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
    //       <div>
    //         <p className="uppercase tracking-wide text-xs text-gray-700">Begrenset periode</p>
    //         <h3 className="text-2xl md:text-3xl font-extrabold text-gray-900">{c.title}</h3>
    //         <p className="text-gray-800 mt-1">{c.body}</p>
    //       </div>
    //       <Button className="bg-purple-700 hover:bg-purple-800 text-white rounded-full px-6 py-3">{c.cta}</Button>
    //     </div>
    //   </div>
    // </section>
  );
}